<template>
  <div class="services">
    <service v-for="(service, i) in services" :key="i" :item="service"></service>
  </div>
</template>

<script>
import Service from './Service'
import Services from '@/data/services'

export default {
  name: 'Services',
  components: {
    Service
  },
  data () {
    return {
      services: Services
    }
  }
}
</script>

<style lang="scss">
.services {
  background: #3f153f;
  position: relative;
  padding: 2rem;
  color: #fff;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-evenly;

  @media screen and (min-width: 960px) {
    padding: 4rem;
    justify-content: start;
  }
}
</style>
